
//import { DirectorioComponent } from './directorio/directorio.component';
//import { HomeComponent } from './home/home.component';
//import { DetalleComponent } from './detalle/detalle.component';
//import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
//import { FilterPipe } from './pipes/filter.pipe';
//import { FilterPipeCategoria } from './pipes/filterCategoria.pipe';
//import { FilterPipeDespachador } from './pipes/filterDespachador.pipe';
//import { appRoutingProviders } from '../app/app-routing.module';

//import { BusquedaComponent } from './busqueda/busqueda.component';
//ya no se usa import { ObjmixnComponent } from './objmixn/objmixn.component';
// import { ObjmixgsComponent } from './objmixgs/objmixgs.component';
//import { ObjMixAgenteComponent } from './obj-mix-agente/obj-mix-agente.component';
//import { ObjmixagenteComponent } from './objmixagente/objmixagente.component';
//import { ScordcardgsComponent } from './scordcardgs/scordcardgs.component';
//import { ReportevtaobjcteComponent } from './reportevtaobjcte/reportevtaobjcte.component';


//import { ObjmixsucursalComponent } from './objmixsucursal/objmixsucursal.component';
//import { RetoTorkBitacoraInicialComponent } from './reto-tork-bitacora-inicial/reto-tork-bitacora-inicial.component';
//import { RetoTorkBitacoraSeguimientoComponent } from './reto-tork-bitacora-seguimiento/reto-tork-bitacora-seguimiento.component';
//import { RetoTorkListaDespachadoresComponent, DialogPreguntasContent, DialogPreguntasContentCons } from './reto-tork-lista-despachadores/reto-tork-lista-despachadores.component';
//import { PoconexionComponent } from './poconexion/poconexion.component';
//import { AutpreciominComponent } from './autpreciomin/autpreciomin.component';
//import { DialogPreciosMinimos } from './autpreciomin/autpreciomin.component';
//import { LoginnComponent } from './loginn/loginn.component';
//import { MatCardModule } from '@angular/material/card';
//import { VtexComponent } from './vtex/vtex.component';
//import { InventariosComponent } from './inventarios/inventarios.component';
//import { ComodatosproComponent } from './comodatospro/comodatospro.component';
//import { DetallescomodaproComponent } from './detallescomodapro/detallescomodapro.component';
//import { ObjmixdivisionalComponent } from './objmixdivisional/objmixdivisional.component';
//import { ObjmixGteSucursalComponent } from './objmix-gte-sucursal/objmix-gte-sucursal.component';
//import { ObjmixGteDivisionalComponent } from './objmix-gte-divisional/objmix-gte-divisional.component';
//import { ObjmixNacionalComponent } from './objmix-nacional/objmix-nacional.component';
//import { FilterprecioPipe } from './pipes/filterprecio.pipe';
//import { CapturadorComponent } from './capturador/capturador.component';
//import { ConfigMercadosComponent } from './config-mercados/config-mercados.component';
/* import { FiltersearchPipe } from './pipes/filtersearch.pipe'; */
//import { PedidosVentasComponent } from './pedidos-ventas/pedidos-ventas.component';
//import { LeadsCarteraComponent } from './leads-cartera/leads-cartera.component';
//import { PipeTableroPipe } from './pipes/pipe-tablero.pipe';
//import { FullCalendarModule } from '@fullcalendar/angular';
//import { CotizacionesComponent } from './cotizaciones/cotizaciones.component';

//import { InsertarComodatosComponent } from './comodatos/comodatos.component'

//import { ListadoComodatosComponent } from './listado-comodatos/listado-comodatos.component';
//import { CarroComodatosComponent } from './carro-comodatos/carro-comodatos.component';
//import { ReportePrincipalComponent } from './reporte-principal/reporte-principal.component';

//import { PlantillasComponent } from './plantillas/plantillas.component';
//import { AgenteFilterPipe } from './pipes/agente-filter.pipe';
//import { PruebasComponent } from './pruebas/pruebas.component';

//import { DetalleOportunidadComponent } from './detalle-oportunidad/detalle-oportunidad.component';
//import { SucursalFilterPipe } from './pipes/sucursal-filter.pipe';
//import { EcodeliPremiaComponent } from './ecodeli-premia/ecodeli-premia.component';
//import { LeadsFamiliasComponent } from './leads-familias/leads-familias.component';
//import { LeadComponent } from './lead/lead.component';
//import { ProspectoComponent } from './prospecto/prospecto.component';

//import { FiltergrupoPipe } from './pipes/filtergrupo.pipe';
//import { SolicitudesFamiliasComponent } from './solicitudes-familias/solicitudes-familias.component';
//import { DetalleLeadsComponent } from './detalle-leads/detalle-leads.component';

//import { ComodatosClienteComponent } from './comodatos-cliente/comodatos-cliente.component';
//import { DetalleFamiliaComponent } from './detalle-familia/detalle-familia.component';
//import { TableroLeadsOportunidadesComponent } from './tablero-leads-oportunidades/tablero-leads-oportunidades.component';
//import { DetalleFamiliaClienteComponent } from './detalle-familia-cliente/detalle-familia-cliente.component';
//import { DetalleFamiliaSucursalComponent } from './detalle-familia-sucursal/detalle-familia-sucursal.component';
//import { SolicitudAltaClienteComponent } from './solicitud-alta-cliente/solicitud-alta-cliente.component';
/* import { ObjMixComponent } from './obj-mix/obj-mix.component'; */
//import { RelojchecadorComponent } from './relojchecador/relojchecador.component';

//import { VentasNetasComponent } from './ventas-netas/ventas-netas.component';
//import { VentasDetalleComponent } from './ventas-detalle/ventas-detalle.component';
//import { ReporteFactvsDevolucionesComponent } from './reporte-factvs-devoluciones/reporte-factvs-devoluciones.component';
//import { ScoreCardComponent } from './score-card/score-card.component';
//import { ListRemisionesComponent } from './list-remisiones/list-remisiones.component';
//import { ListadoEvidenciasComodatosComponent } from './listado-evidencias-comodatos/listado-evidencias-comodatos.component';
//import { ListadoComplementoPagoComponent } from './listado-complemento-pago/listado-complemento-pago.component';
//import { ListadoReporteEmbarquesComponent } from './listado-reporte-embarques/listado-reporte-embarques.component';

//import { loader } from './widgets/loader/loader.component';
//import { CotizadorLineaComponent } from './cotizador-linea/cotizador-linea.component';
//import { CotizadorSubLineaComponent } from './cotizador-sub-linea/cotizador-sub-linea.component';
//import { CotizadorArticulosComponent } from './cotizador-articulos/cotizador-articulos.component'
//import { DetalleArticuloComponent } from './detalle-articulo/detalle-articulo.component';

//import { ComprasindirectasComponent } from './comprasindirectas/comprasindirectas.component';
//import { SolicitudpresupuestosComponent } from './solicitudpresupuestos/solicitudpresupuestos.component';
//import { CatalogoComponent } from './catalogo/catalogo.component'

//import { ComodatoDetalleComponent } from './comodato-detalle/comodato-detalle.component';
//import { ComodatosLineasComponent } from './comodatos-lineas/comodatos-lineas.component';
//import { ComodatosArticulosComponent } from './comodatos-articulos/comodatos-articulos.component';

//import { PedidosPendientesComponent } from './pedidos-pendientes/pedidos-pendientes.component';
//import { RemisionesPendientesComponent } from './remisiones-pendientes/remisiones-pendientes.component';
//import { ReporteAvanceGerenteComponent } from './reporte-avance-gerente/reporte-avance-gerente.component';
//import { CostosDetalleArticuloComponent } from './costos-detalle-articulo/costos-detalle-articulo.component';
//import { ReporteVentadiariaComponent } from './reporte-ventadiaria/reporte-ventadiaria.component';
//import { ClientesFaltantesComponent } from './clientes-faltantes/clientes-faltantes.component';
//import { MinutaLeadComponent } from './minuta-lead/minuta-lead.component';
//import { ConcursoInscripcionComponent } from './concurso-inscripcion/concurso-inscripcion.component';
//import { ReporteComodatosClienteComponent } from './reporte-comodatos-cliente/reporte-comodatos-cliente.component';

/* import { AdminCuponesComponent } from './admin-cupones/admin-cupones.component';
 import { EcommercePedidosComponent } from './ecommerce-pedidos/ecommerce-pedidos.component';
import { EcommerceAdminArtComponent } from './ecommerce-admin-art/ecommerce-admin-art.component';
import { EcommerceBannersAdminComponent } from './ecommerce-banners-admin/ecommerce-banners-admin.component';
import { UsuariosPartnerComponent } from './usuarios-partner/usuarios-partner.component';
import { PartnerAdminDescuentosComponent } from './partner-admin-descuentos/partner-admin-descuentos.component';
import { PartnerPedidosComponent } from './partner-pedidos/partner-pedidos.component';
import { ArticuloTresMComponent } from './articulo-tres-m/articulo-tres-m.component';
*/


//import { ClienteReportePrincipalNewComponent } from './cliente-reporte-principal-new/cliente-reporte-principal-new.component';
//import { ClienteReportePrincipalComponent } from './cliente-reporte-principal/cliente-reporte-principal.component';
//import { ClientePreciosEspecialesComponent } from './cliente-precios-especiales/cliente-precios-especiales.component';
//import { ClienteFacturasComponent } from './cliente-facturas/cliente-facturas.component';
//import { ClienteComplementopagoComponent } from './cliente-complementopago/cliente-complementopago.component';
//import { EstadoCuentaComponent } from './estado-cuenta/estado-cuenta.component';
//import { DatosFiscalesCteComponent } from './datos-fiscales-cte/datos-fiscales-cte.component';
//import { ClienteSucursalesComponent } from './cliente-sucursales/cliente-sucursales.component';
//import { ClienteSolicitudPedidoComponent } from './cliente-solicitud-pedido/cliente-solicitud-pedido.component';
//import { ClienteSeguimientoPedidosComponent } from './cliente-seguimiento-pedidos/cliente-seguimiento-pedidos.component';
//import { ClienteRutaPedidosComponent } from './cliente-ruta-pedidos/cliente-ruta-pedidos.component';
//import { ClienteVentaArticuloComponent } from './cliente-venta-articulo/cliente-venta-articulo.component';
//import { ClienteVentaLineaComponent } from './cliente-venta-linea/cliente-venta-linea.component';
//import { ClientePresupuestoSucursalComponent } from './cliente-presupuesto-sucursal/cliente-presupuesto-sucursal.component';
//import { ClienteVentaMontoComponent } from './cliente-venta-monto/cliente-venta-monto.component';


//import { PartnerRegistroComponent } from './partner-registro/partner-registro.component';
//import { PartnerInicioSesionComponent } from './partner-inicio-sesion/partner-inicio-sesion.component';
//import { PartnerEntregaComponent } from './partner-entrega/partner-entrega.component';
//import { PartnerFinpedidoComponent } from './partner-finpedido/partner-finpedido.component';
//import { PartnerFinpedidoTransferenciaComponent } from './partner-finpedido-transferencia/partner-finpedido-transferencia.component';
//import { PartnerErrorCompraComponent } from './partner-error-compra/partner-error-compra.component';
//import { PartnerPrincipalComponent } from './partner-principal/partner-principal.component';
//import { PartnerBeneficiosComponent } from './partner-beneficios/partner-beneficios.component';
//import { PartnerRecompensasComponent } from './partner-recompensas/partner-recompensas.component';
//import { PartnerMicuentaComponent } from './partner-micuenta/partner-micuenta.component';
//import { PartnerMispedidosComponent } from './partner-mispedidos/partner-mispedidos.component';
//import { PartnerCarritoComponent } from './partner-carrito/partner-carrito.component';
//import { PartnerClientesComponent } from './partner-clientes/partner-clientes.component';
//import { CotizadorPartnerComponent } from './cotizador-partner/cotizador-partner.component';
//import { PartnerPasarelaComponent } from './partner-pasarela/partner-pasarela.component';
//import { PartnerOfertaMesComponent } from './partner-oferta-mes/partner-oferta-mes.component';
//import { PartnerDescuentosComponent } from './partner-descuentos/partner-descuentos.component';
//import { PartnerDetalleDescuentosComponent } from './partner-detalle-descuentos/partner-detalle-descuentos.component';

//import { PoliticaComponent } from './politica/politica.component';
/* 
import { FilterEcommercePipe } from './pipes/filter-ecommerce.pipe'; */

//import { SearchProspectacionComponent } from './search-prospectacion/search-prospectacion.component';


//import { PartnerOfertasComponent } from './partner-ofertas/partner-ofertas.component';
//import { FiltrarAlmArticulosPipe } from './pipes/filtrar-alm-articulos.pipe';
//import { FiltrarAlmOriDesPipe } from './pipes/filtrar-alm-ori-des.pipe';
//import { FiltrarAlmOrigenDestinoPipe } from './pipes/filtrar-alm-origen-destino.pipe';


//import { UsuariosComercialComponent } from './usuarios-comercial/usuarios-comercial.component';

//import { PedidosCastoresComponent } from './pedidos-castores/pedidos-castores.component';
//import { PartnerHomeComponent } from './partner-home/partner-home.component';


/* import { PartnerSolicitudContrasenaComponent } from './partner-solicitud-contrasena/partner-solicitud-contrasena.component';
import { PartnerNuevaContrasenaComponent } from './partner-nueva-contrasena/partner-nueva-contrasena.component';
import { PartnerConfirmacionContrasenaComponent } from './partner-confirmacion-contrasena/partner-confirmacion-contrasena.component';
import { LoginPartnerComponent } from './login-partner/login-partner.component';
import { PartnerInfoComponent } from './partner-info/partner-info.component'; */
//import { PlaneadorComprasExcedenteComponent } from './planeador-compras-excedente/planeador-compras-excedente.component';
//import { PlaneadorLogisticaComponent } from './planeador-logistica/planeador-logistica.component';
//import { PlaneadorTraspasosNacionalComponent } from './planeador-traspasos-nacional/planeador-traspasos-nacional.component';
//import { PlaneadorCapacidadAlamacenComponent } from './planeador-capacidad-alamacen/planeador-capacidad-alamacen.component';
//import { PlaneadorComprasComponent } from './planeador-compras/planeador-compras.component';
//import { PlaneadorClavesSustitutasComponent } from './planeador-claves-sustitutas/planeador-claves-sustitutas.component';

//import { TransitosComprasComponent } from './transitos-compras/transitos-compras.component';
//import { TransitosComponent } from './transitos/transitos.component';
//import { TransitosGeneradosComponent } from './transitos-generados/transitos-generados.component';
//import { TransitosIndicadoresComponent } from './transitos-indicadores/transitos-indicadores.component';
//import { TransitosGeneradosEncabezadoComponent } from './transitos-generados-encabezado/transitos-generados-encabezado.component';

//import { FilterDespachadorPipe } from './pipes/filter-despachador.pipe';

//pasados a lazy
//import { RetoTorkComponent } from './reto-tork/reto-tork.component';
//import { EcommerceAyudaComponent } from './ecommerce-ayuda/ecommerce-ayuda.component';
//import { EcommerceLoginComponent } from './ecommerce-login/ecommerce-login.component';
//import { EcommerceRegisterComponent } from './ecommerce-register/ecommerce-register.component';
//import { EcommerceFacturaDataComponent } from './ecommerce-factura-data/ecommerce-factura-data.component';
//import { EcommercePerfilComponent } from './ecommerce-perfil/ecommerce-perfil.component';
//import { EcommerceUserDireccionComponent } from './ecommerce-user-direccion/ecommerce-user-direccion.component';
//import { EcommerceCarritoComponent } from './ecommerce-carrito/ecommerce-carrito.component';

//COMENTO MARTIN
 //import { MatExpansionModule } from '@angular/material/expansion';
//import { MatRadioModule } from '@angular/material/radio';
//import { MatInputCommifiedDirective } from './mat-input-commified.directive';
 import { MatInputModule } from '@angular/material/input';
 import { MatIconModule } from '@angular/material/icon';
//import { MatSelectModule } from '@angular/material/select';
 import { MatButtonModule } from '@angular/material/button';
//import { MatDialogModule } from '@angular/material/dialog';
//import { MatProgressBarModule } from '@angular/material/progress-bar';
 import { MatToolbarModule } from '@angular/material/toolbar';
//import { MatGridListModule } from '@angular/material/grid-list';

 import { MatListModule } from '@angular/material/list';
//import { MatAutocompleteModule } from '@angular/material/autocomplete';
//import { MatSelectFilterModule } from 'mat-select-filter';
//import { MatMomentDateModule } from '@angular/material-moment-adapter';
//-------------------------------------------------------------------------
//import { ReportecomodatosComponent } from './reportecomodatos/reportecomodatos.component';
 import { LayoutModule } from '@angular/cdk/layout';
//import { CarritoresumenComponent } from './carritoresumen/carritoresumen.component';
//import { CotizadornewComponent } from './cotizadornew/cotizadornew.component';
//import { MatStepperModule } from '@angular/material/stepper';
//import { EcommerceTerminoenvioComponent } from './ecommerce-terminoenvio/ecommerce-terminoenvio.component';

//import { PlantillaFiltrosComponent } from './plantilla-filtros/plantilla-filtros.component';
//import { VentaConsignaComponent } from './venta-consigna/venta-consigna.component';
//import { CancelarPedidoComponent } from './cancelar-pedido/cancelar-pedido.component';
//import { AltaclienteComponent } from './altacliente/altacliente.component';

//import { AromiaComponent } from './aromia/aromia.component';
//import { PedidosEcodeliComponent } from './pedidos-ecodeli/pedidos-ecodeli.component';
//import { InventariosEcodeliComponent } from './inventarios-ecodeli/inventarios-ecodeli.component';
//import { ListadoComodatosTodosComponent } from './listado-comodatos-todos/listado-comodatos-todos.component';
//import { CotizadorComponent } from './cotizador/cotizador.component';
// no se que es import { FormularioLeadComponent } from './formulario-lead/formulario-lead.component';
//import { SolicitudActualizacionCreditoComponent } from './solicitud-actualizacion-credito/solicitud-actualizacion-credito.component';
//import { ActualizacionDatosGeneralesComponent } from './actualizacion-datos-generales/actualizacion-datos-generales.component';
// import { DashboardVendedorComponent } from './dashboard-vendedor/dashboard-vendedor.component';
//import { VacantesComponent } from './vacantes/vacantes.component';
//import { DetallePedidosPComponent } from './detalle-pedidos-p/detalle-pedidos-p.component';
//import { EcommerceProductoComponent } from './ecommerce-producto/ecommerce-producto.component';
//import { EcommerceUserInicioComponent } from './ecommerce-user-inicio/ecommerce-user-inicio.component';
//import { EcommercePedidosCteComponent } from './ecommerce-pedidos-cte/ecommerce-pedidos-cte.component';
//import { EcommerceRastrearPedidoComponent } from './ecommerce-rastrear-pedido/ecommerce-rastrear-pedido.component';
//import { BannerArtComponent } from './banner-art/banner-art.component';
//import { ClienteDetallePedidoComponent } from './cliente-detalle-pedido/cliente-detalle-pedido.component';
//import { EcommercePrivacidadComponent } from './ecommerce-privacidad/ecommerce-privacidad.component';
//import { PasarelaPagoComponent } from './pasarela-pago/pasarela-pago.component';

//import { TiendaFinpedidoComponent } from './tienda-finpedido/tienda-finpedido.component';
//import { EcommerceFinpedidoComponent } from './ecommerce-finpedido/ecommerce-finpedido.component';
//import { PagoErrorComponent } from './pago-error/pago-error.component';
//import { FamiliasComponent } from './familias/familias.component';

//import { CambioDomicilioFiscalComponent } from './cambio-domicilio-fiscal/cambio-domicilio-fiscal.component';
//import { ClienteReporteExcedidosComponent } from './cliente-reporte-excedidos/cliente-reporte-excedidos.component';
//import { AltaSucursalClienteComponent } from './alta-sucursal-cliente/alta-sucursal-cliente.component';
//import { DetalleContactoComponent } from './detalle-contacto/detalle-contacto.component'
//import { DetalleRemisionComponent } from './detalle-remision/detalle-remision.component';
//import { PartnerDesempenioComponent } from './partner-desempenio/partner-desempenio.component';
//import { ConvenioFamiliaComponent } from './convenio-familia/convenio-familia.component';

 
//import { GoogleMapsModule } from '@angular/google-maps';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms'; //necesario para trabajr con two way data-binding
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatCurrencyFormatModule } from 'mat-currency-format';
//import { MatPaginatorModule } from '@angular/material/paginator';
//import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
//import { MatTabsModule } from '@angular/material/tabs';
//import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { ClientePedidoPipe } from './pipes/cliente-pedido.pipe';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { ListadoComponent } from './listado/listado.component';
import { PeticionesService } from './servicios/httpservice';
import { CarroService } from './servicios/carroservice';
import { FooterComponent } from './footer/footer.component';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//import { LoginComponent } from './login/login.component';
import { DetallevtasvsobjComponent } from './detallevtasvsobj/detallevtasvsobj.component';
import { FirmaComponent } from './firma/firma.component';
//import { SeguimientotorkComponent } from './seguimientotork/seguimientotork.component';
import { DialogAutorizarRetoComponent } from './dialog-autorizar-reto/dialog-autorizar-reto.component';
import { NewmenuComponent } from './newmenu/newmenu.component';

import { MatSidenavModule } from '@angular/material/sidenav';

import { MatMenuModule } from '@angular/material/menu';
//import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { FilterAllPipe } from './pipes/filter-all.pipe';


import { DatePipe } from '@angular/common';
//import { AltaReglaNegocioComponent } from './alta-regla-negocio/alta-regla-negocio.component';
//import { SolicitudIvaFronterizoComponent } from './solicitud-iva-fronterizo/solicitud-iva-fronterizo.component';
import { RecursosHumanosService } from './servicios/recursos-humanos.service';
// NO BORRAR -- NUEVA IMAGEN DE ECOMMERCE import { EcommerceNewComponent } from './ecommerce-new/ecommerce-new.component';
import { SharedModule } from './shared/shared.module'
//import { SearchMeiliComponent } from './search-meili/search-meili.component';

import { MatPaginatorIntl } from '@angular/material/paginator';
import { FilterPlaneadorPipe } from './pipes/filter-planeador.pipe';
 import { EcommerceComponent } from './ecommerce/ecommerce.component'
//import { EcommerceDetallearticuloComponent } from './ecommerce-detallearticulo/ecommerce-detallearticulo.component';
//import { EcommerceDetalleCategoriaComponent } from './ecommerce-detalle-categoria/ecommerce-detalle-categoria.component';
//import { EcommerceDetalleArtCategoriaComponent } from './ecommerce-detalle-art-categoria/ecommerce-detalle-art-categoria.component';
import { IconosLoginComponent } from './iconos-login/iconos-login.component';
//import { PlaneadorCapturadorTransitosComponent } from './planeador-capturador-transitos/planeador-capturador-transitos.component';

//import { ReporteFamCteComponent } from './reporte-fam-cte/reporte-fam-cte.component';


//import { PlaneadorProveedoresComponent } from './planeador-proveedores/planeador-proveedores.component';
//import { ReporteFaltantesComponent } from './reporte-faltantes/reporte-faltantes.component';
//import { CierreMesComponent } from './cierre-mes/cierre-mes.component';




@NgModule({
  declarations: [
    AppComponent,
    //ClientePedidoPipe,
    // SeguimientotorkComponent,
    FooterComponent,
    FirmaComponent,
   
    //LoginComponent,
    DialogAutorizarRetoComponent,
    NewmenuComponent,
    DetallevtasvsobjComponent,
    //revisar si se usa FilterAllPipe,
   // EcommerceDetallearticuloComponent,
     EcommerceComponent, 
     //EcommerceDetalleCategoriaComponent,
    //EcommerceDetalleArtCategoriaComponent, 
    IconosLoginComponent, // PlaneadorCapturadorTransitosComponent,// ReporteFamCteComponent,  //PlaneadorProveedoresComponent, //ReporteFaltantesComponent,
    //, CierreMesComponent, 
   // FilterPlaneadorPipe,
   // FamiliasComponent,
    //AltaSucursalClienteComponent,
   // AltaReglaNegocioComponent,
   //  SolicitudIvaFronterizoComponent,
    //ConvenioFamiliaComponent,
    //DetalleContactoComponent,
    //CambioDomicilioFiscalComponent,
   
    //DetalleRemisionComponent,
    
    //TiendaFinpedidoComponent,
    // EcommerceFinpedidoComponent, PagoErrorComponent,
   // PartnerDesempenioComponent,
    //ClienteReporteExcedidosComponent,
    
    //EcommerceNewComponent,
    // SearchMeiliComponent,
    //PasarelaPagoComponent,
    //DetalleComponent, 
    //EcommercePrivacidadComponent,
    //ClienteDetallePedidoComponent,
   // BannerArtComponent,
    //CarritoresumenComponent,
    // DirectorioComponent,
    //HomeComponent,
    //BusquedaComponent,
    //ObjmixnComponent,
    //ObjmixsucursalComponent,
    // LoginnComponent, 
    //ObjmixgsComponent,// ObjMixAgenteComponent,ObjmixagenteComponent,
    //MatInputCommifiedDirective,
    //ScordcardgsComponent,
    //FilterPipe,
    // FilterPipeCategoria,
    // FilterPipeDespachador,
    //ReportecomodatosComponent,
    //ReportevtaobjcteComponent,
    //pasados a lazy --RetoTorkComponent,
    // RetoTorkBitacoraInicialComponent, 
    // RetoTorkBitacoraSeguimientoComponent,
    // RetoTorkListaDespachadoresComponent,
    //DialogPreguntasContent, DialogPreguntasContentCons,
    //PoconexionComponent, 
    //AutpreciominComponent,
    //DialogPreciosMinimos, 
    //CotizadornewComponent,
    //ComodatosproComponent, 
    //DetallescomodaproComponent,
    //VtexComponent,
    //InventariosComponent,
    //ObjmixGteSucursalComponent,
    //ObjmixGteDivisionalComponent,
    //ObjmixNacionalComponent,
    //ObjmixdivisionalComponent,
    //FilterprecioPipe,
    //CapturadorComponent, 
    //ConfigMercadosComponent,
    //FiltersearchPipe, SucursalFilterPipe,  AgenteFilterPipe, 
    //PedidosVentasComponent,
    // LeadsCarteraComponent,
    //PipeTableroPipe,
    //CotizacionesComponent,
    // no se isa AromiaComponent,
    // InsertarComodatosComponent, 
    //ListadoComodatosComponent,
    //CarroComodatosComponent, 
    // ListadoComodatosTodosComponent,
    // ReportePrincipalComponent,
    //PedidosEcodeliComponent, 
    //InventariosEcodeliComponent,
    //PlantillasComponent,
    // EcodeliPremiaComponent,
    //LeadsFamiliasComponent,
    // LeadComponent, 
    // ProspectoComponent,
    // AltaclienteComponent,
    //FiltergrupoPipe, 
    //SolicitudesFamiliasComponent, 
    //DetalleLeadsComponent,
    //no se que es FormularioLeadComponent,
    // ComodatosClienteComponent,
    // DetalleFamiliaComponent, 
    // TableroLeadsOportunidadesComponent, 
    // PruebasComponent,
    //CotizadorComponent,
    // DetalleOportunidadComponent,
    // DetalleFamiliaClienteComponent,
    // DetalleFamiliaSucursalComponent,
    //  DashboardVendedorComponent,
    // SolicitudAltaClienteComponent,
    //SolicitudActualizacionCreditoComponent,
    // ActualizacionDatosGeneralesComponent,
    //, ObjMixComponent
    //RelojchecadorComponent,
    // VacantesComponent,
    //loader,  dataTable,
    // VentasNetasComponent,
    // VentasDetalleComponent,
    //  ReporteFactvsDevolucionesComponent,
    // ScoreCardComponent,
    //ListRemisionesComponent,
    //ListadoEvidenciasComodatosComponent,
    //   ListadoComplementoPagoComponent,
    //ListadoReporteEmbarquesComponent, 
    // CotizadorLineaComponent,
    // CotizadorSubLineaComponent, 
    // CotizadorArticulosComponent,
    //DetalleArticuloComponent,
    //ComprasindirectasComponent,
    // SolicitudpresupuestosComponent,
    // CatalogoComponent, 
    //ComodatoDetalleComponent, 
    //ComodatosLineasComponent, 
    //ComodatosArticulosComponent, 
    //PedidosPendientesComponent,
    //DetallePedidosPComponent,
    // RemisionesPendientesComponent,
    // ReporteAvanceGerenteComponent,
    //CostosDetalleArticuloComponent,
    // ReporteVentadiariaComponent,
    //VentaConsignaComponent,
    //CancelarPedidoComponent,
    // ClientesFaltantesComponent,
    // EcommercePedidosComponent,
    //AdminCuponesComponent,
    //EcommerceAdminArtComponent,
    //EcommerceBannersAdminComponent,
    //UsuariosPartnerComponent,
    //PartnerAdminDescuentosComponent, 
    //PartnerPedidosComponent,
    //ArticuloTresMComponent,
    //FilterEcommercePipe,
    //  FiltrarAlmArticulosPipe, 
    //PlantillaFiltrosComponent, 
    //MinutaLeadComponent,
    //ConcursoInscripcionComponent,
    //ReporteComodatosClienteComponent,
    // FiltrarAlmOriDesPipe,
    //  FiltrarAlmOrigenDestinoPipe, 
    //ClienteReportePrincipalComponent,
    //ClienteReportePrincipalNewComponent,
    //ClientePreciosEspecialesComponent,
    //  ClienteFacturasComponent,    
    // EstadoCuentaComponent, 
    //  DatosFiscalesCteComponent, 
    // ClienteSucursalesComponent,
    //ClienteComplementopagoComponent,
    // ClienteSolicitudPedidoComponent,
    //ClienteSeguimientoPedidosComponent,
    //ClienteRutaPedidosComponent, 
    // ClienteVentaArticuloComponent,
    // ClienteVentaLineaComponent,
    // ClientePresupuestoSucursalComponent,
    //ClienteVentaMontoComponent, 
    // EcommerceCarritoComponent, 
    // EcommerceAyudaComponent,
    //  EcommerceLoginComponent,
    //  EcommerceRegisterComponent, 
    // EcommerceUserDireccionComponent,
    //   EcommercePerfilComponent,
    //  EcommerceFacturaDataComponent,
    //EcommerceProductoComponent, 
    // EcommerceUserInicioComponent,
    //EcommercePedidosCteComponent, 
    //EcommerceRastrearPedidoComponent, 
    //EcommerceTerminoenvioComponent,  
    //PartnerRegistroComponent,
    // PartnerInicioSesionComponent, 
    //PartnerEntregaComponent,
    //PartnerPrincipalComponent,
    //PartnerRecompensasComponent,
    //PartnerBeneficiosComponent,
    //PartnerErrorCompraComponent,
    //PartnerFinpedidoComponent, 
    //PartnerFinpedidoTransferenciaComponent,
    //PartnerCarritoComponent,
    //PartnerPasarelaComponent,
    //PartnerMispedidosComponent,
    //PartnerOfertaMesComponent,
    //PartnerClientesComponent,
    //PartnerDetalleDescuentosComponent,
    //CotizadorPartnerComponent,
    //PartnerDescuentosComponent,
    //PartnerHomeComponent,
    //PartnerMicuentaComponent, 
    // PoliticaComponent,
    //  PartnerOfertasComponent,
    /* PartnerSolicitudContrasenaComponent,
 PartnerNuevaContrasenaComponent, 
 PartnerConfirmacionContrasenaComponent, 
  LoginPartnerComponent, 
  PartnerInfoComponent,  */
    // SearchProspectacionComponent,
    // UsuariosComercialComponent,
    //PedidosCastoresComponent,
    //PlaneadorComprasExcedenteComponent,
    //, FilterDespachadorPipe
    // PlaneadorLogisticaComponent, 
    // TransitosIndicadoresComponent,
    //  PlaneadorCapacidadAlamacenComponent,
    //  TransitosComprasComponent,
    //  PlaneadorClavesSustitutasComponent, 
    // PlaneadorTraspasosNacionalComponent 
    // TransitosComponent, 
    //  PlaneadorComprasComponent, 
    // TransitosGeneradosComponent, 
    // TransitosGeneradosEncabezadoComponent,
  ],
  imports: [
    NgxWebstorageModule.forRoot(
    ),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
   // ReactiveFormsModule,
    BrowserAnimationsModule,
    //MatPaginatorModule,
    //MatTableModule,
     MatFormFieldModule,
     // MatTabsModule,
    //MatSortModule,
   // MatCurrencyFormatModule,
    MatSlideToggleModule,
    //MatDatepickerModule,
    MatSidenavModule,
    MatMenuModule,
    MatTooltipModule,
    //MatNativeDateModule, 
    //SharedModule,
    //FullCalendarModule,
    //MatRadioModule,
    MatInputModule,
    MatIconModule,
    //MatSelectModule,
     MatButtonModule,
    //MatDialogModule,
    //MatMomentDateModule,
    //MatProgressSpinnerModule,
    //MatProgressBarModule,
    //MatStepperModule,
     LayoutModule,
    MatToolbarModule,
    MatListModule,
    //MatGridListModule, 
    //MatAutocompleteModule,
     //MatExpansionModule,
    // MatSelectFilterModule,
  ],
  entryComponents: [
    DetallevtasvsobjComponent
  ],

  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }, PeticionesService, CarroService, CurrencyPipe, DatePipe, RecursosHumanosService, { provide: MatPaginatorIntl }],
  //providers: [appRoutingProviders, { provide: APP_BASE_HREF, useValue : '/' }, PeticionesService, CarroService,CurrencyPipe],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
